import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotSliders = ({
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <path
            fill={spotColor}
            d="M10.366 3.178C6.115 6.069-1.106 13.056 1.223 19.073c-.207.296-.39.61-.546.935-3.627 7.793 8.234 11.507 13.792 7.957a16.856 16.856 0 0 0 4.147-2.32 22.234 22.234 0 0 0 6.814-3.706c5.134-4.008 9.385-11.385 4.234-17.558-5.152-6.173-13.567-5.108-19.298-1.203Z"
            opacity={0.8}
        />
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            d="M6.668 35V23.332m0-6.666V5m13.333 30V20m0-6.667V5m13.333 30v-8.333m0-6.667V5M1.668 23.333h10m3.333-10h10m3.333 13.334h10"
        />
    </SVG>
);
SpotSliders.displayName = "SpotSliders";
